import { STATUS_OPTIONS } from "@/lib/constants";
import { cn } from "@/lib/utils";

export const StatusStepper = ({ status }) => {
  const current = STATUS_OPTIONS.indexOf(status);
  return (
    <ol className="grid grid-cols-3 gap-2" data-testid="status-stepper">
      {STATUS_OPTIONS.map((s, i) => (
        <li key={s} className="space-y-2">
          <div className={cn("h-1.5 rounded-full transition-colors duration-500", i <= current ? "bg-emerald-500" : "bg-slate-200")} />
          <p
            className={cn("text-xs font-semibold", i === current ? "text-emerald-700" : i < current ? "text-slate-600" : "text-slate-400")}
            data-testid={i === current ? "status-stepper-current" : undefined}
          >
            {i + 1}. {s}
          </p>
        </li>
      ))}
    </ol>
  );
};
